import React, { useEffect, useState } from "react";
import API_BASE from "../config/api";

// Fallback shown until/unless an admin customizes this page
// (Admin Panel -> Page Management -> Contact) — same pattern as AboutUs.jsx.
const DEFAULTS = {
    heading: "Contact Us",
    subheading: "We're here to help! Reach out to us using the form below or via our contact details.",
    address: "Nepalgunj Banke, Bheri, Lumbini Province, Nepal",
    phone: "+977-9848427993",
    email: "support@dialnepal.com.np",
    hours: "Mon – Fri : 9:00 AM – 6:00 PM",
    mapEmbedUrl: "https://maps.google.com/maps?q=Kathmandu&t=&z=13&ie=UTF8&iwloc=&output=embed",
};

const ContactUs = () => {
    const [c, setC] = useState(DEFAULTS);
    const [formData, setFormData] = useState({ fullName: "", email: "", phone: "", subject: "", message: "" });
    const [submitting, setSubmitting] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        fetch(`${API_BASE}/api/get_site_page.php?key=contact`)
            .then((r) => r.json())
            .then((res) => { if (res.success && res.content) setC({ ...DEFAULTS, ...res.content }); })
            .catch(() => { /* keep defaults */ });
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setResult(null);
        try {
            const res = await fetch(`${API_BASE}/api/save_contact_message.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    full_name: formData.fullName,
                    email: formData.email,
                    phone: formData.phone,
                    subject: formData.subject,
                    message: formData.message,
                }),
            });
            const data = await res.json();
            setSubmitting(false);
            if (data.success) {
                setResult({ type: "success", text: "Message sent! We'll get back to you soon." });
                setFormData({ fullName: "", email: "", phone: "", subject: "", message: "" });
            } else {
                setResult({ type: "danger", text: data.message || "Could not send. Please try again." });
            }
        } catch {
            setSubmitting(false);
            setResult({ type: "danger", text: "Network error. Please try again." });
        }
    };

    return (
        <div className="container py-5">
            {/* Page Heading */}
            <div className="text-center mb-5">
                <h2 className="fw-bold">{c.heading}</h2>
                <p className="text-muted">{c.subheading}</p>
            </div>

            {/* Row 1: Form + Contact Details */}
            <div className="row g-4">
                {/* Contact Form */}
                <div className="col-lg-6">
                    <div className="card p-4 shadow-sm border-0">
                        <h5 className="fw-bold mb-3">Send Us a Message</h5>

                        {result && <div className={`alert alert-${result.type} py-2`}>{result.text}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="fullName"
                                    value={formData.fullName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Phone Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Subject</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="subject"
                                    value={formData.subject}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Message</label>
                                <textarea
                                    className="form-control"
                                    rows="4"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                ></textarea>
                            </div>

                            <button type="submit" className="btn btn-primary w-100 py-2" disabled={submitting}>
                                {submitting ? "Sending..." : "Send Message"}
                            </button>
                        </form>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="col-lg-6">
                    <div className="card p-4 shadow-sm border-0">
                        <h5 className="fw-bold mb-3">Contact Information</h5>

                        <p className="mb-2"><strong>📍 Address:</strong></p>
                        <p className="text-muted">{c.address}</p>

                        <p className="mb-2"><strong>📞 Phone:</strong></p>
                        <p className="text-muted">{c.phone}</p>

                        <p className="mb-2"><strong>📧 Email:</strong></p>
                        <p className="text-muted">{c.email}</p>

                        <p className="mb-2"><strong>🕒 Working Hours:</strong></p>
                        <p className="text-muted">{c.hours}</p>
                    </div>
                </div>
            </div>

            {/* Row 2: Map */}
            <div className="row mt-5">
                <div className="col-12">
                    <div className="card shadow-sm border-0">
                        <iframe
                            title="map"
                            src={c.mapEmbedUrl}
                            width="100%"
                            height="350"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                        ></iframe>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ContactUs;
